import { Grid, useTheme } from "@mui/material";
import React, { ReactElement } from "react";
import { Base } from "../../base";

interface Props {
  updateSearch: (value: string) => void;
  searchValue?: string;
  modalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  reset: () => void;
  children: ReactElement;
  hideNew?: boolean;
  extraFunction?: { function: () => void; text: string };
}

const SearchContainer: React.FC<Props> = (props) => {
  const {
    updateSearch,
    searchValue,
    modalOpen,
    reset,
    children,
    hideNew,
    extraFunction,
  } = props;
  const theme = useTheme();

  return (
    <Grid container rowGap={2}>
      <Grid size={{ xs: 12 }}>
        <Grid
          container
          direction={{ md: "row", xs: "column-reverse" }}
          alignItems={"center"}
          columnSpacing={{ md: 3, xs: 0 }}
        >
          <Grid
            size={{ md: !!hideNew ? 12 : 10 }}
            alignSelf={"stretch"}
            m={{ md: 0, xs: 3 }}
          >
            <Base.Search
              label="Search"
              handleChange={updateSearch}
              value={searchValue}
            />
          </Grid>
          {!!extraFunction && (
            <Grid size={{ md: 1 }}>
              <Base.Button
                text={extraFunction.text}
                onClick={extraFunction.function}
                fullWidth
                type="secondary"
              />
            </Grid>
          )}
          {!hideNew && (
            <Grid size={{ md: !!extraFunction ? 1 : 2 }}>
              <Base.Button
                text={"New"}
                onClick={() => {
                  modalOpen(true);
                  reset();
                }}
                fullWidth
              />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid
        size={{ xs: 12 }}
        pb={{ xs: 15, md: 5 }}
        sx={{
          "& .header": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default SearchContainer;
